__turbopack_context__.v({
  "contentAnimation": "competenciesScroll-module__UbmGTW__contentAnimation",
  "fadeInUp": "competenciesScroll-module__UbmGTW__fadeInUp",
  "imageAnimation": "competenciesScroll-module__UbmGTW__imageAnimation",
  "sectionAnimation": "competenciesScroll-module__UbmGTW__sectionAnimation",
});
